/**
 * determines familyStatusIndicator object containing familyStatusIndicator(s) from each provider tier & secondary plan benefits
 * used in the Member Benefits Service
 * @param {Object} response - eligibility response
 */
export const getMemberBenefitsFamilyStatusIndicator = (response) => {
    const familyStatusIndicator = {};

    const planBenefitsArray = response?.data?.member?.planLevelBenefits;
    planBenefitsArray.forEach((planLevel) => {
        if ('nonEmbeddedFamilyStatusIndicator' in planLevel) {
            //if there is a status indicator,
            familyStatusIndicator[planLevel.tier] = planLevel.nonEmbeddedFamilyStatusIndicator; //make a new property with the tier name and status indicator
        }
    });
    familyStatusIndicator.planBenefitIndicators =
        response?.data?.member?.planBenefitIndicators?.nonEmbeddedFamilyStatusIndicator;
    return familyStatusIndicator;
};

/**
 * determines which familyStatusIndicator to use for a given provider tier
 * used in the Single Estimate page
 * @param {String} providerTierLevel - provider tier value
 * @param {Object} nonEmbeddedFamilyStatusIndicator - object containing familyStatusIndicators for each tier
 * @param {Boolean} renderInNetwork - boolean for INN or OON
 */
export const determineSingleEstimateFamilyStatusIndicator = (
    providerTierLevel,
    nonEmbeddedFamilyStatusIndicator,
    renderInNetwork
) => {
    let networkBasedFamilyStatusIndicator = {};

    let providerTierLevelPresent = false;
    if (nonEmbeddedFamilyStatusIndicator) {
        if (providerTierLevel in nonEmbeddedFamilyStatusIndicator) {
            providerTierLevelPresent = true;
        }
        if (providerTierLevelPresent) {
            networkBasedFamilyStatusIndicator = nonEmbeddedFamilyStatusIndicator[providerTierLevel];
        } else if (
            'planBenefitIndicators' in nonEmbeddedFamilyStatusIndicator &&
            providerTierLevel
        ) {
            networkBasedFamilyStatusIndicator =
                nonEmbeddedFamilyStatusIndicator.planBenefitIndicators;
        } else if (
            'IN-NETWORK' in nonEmbeddedFamilyStatusIndicator ||
            'OUT-NETWORK' in nonEmbeddedFamilyStatusIndicator
        ) {
            networkBasedFamilyStatusIndicator = renderInNetwork
                ? nonEmbeddedFamilyStatusIndicator['IN-NETWORK']
                : nonEmbeddedFamilyStatusIndicator['OUT-NETWORK'];
        } else {
            networkBasedFamilyStatusIndicator =
                nonEmbeddedFamilyStatusIndicator[Object.keys(nonEmbeddedFamilyStatusIndicator)[0]];
        }
    }

    return networkBasedFamilyStatusIndicator;
};

export const getTciTableNumberFromPlanBenefits = (response) => {
    return response?.data?.member?.planBenefitIndicators?.tciTableNumberId;
};

/**
 * Uses plan details response to determine whether a member has ddp Lab Benefits, relevant for rate/cost calculation
 * @param {Object} planBenefitsResponse response returned from our plan /benefits endpoint which holds the member's plan detail info
 * @returns {Boolean} true if member has a service level benefit for lab services, else false
 */
export const determineDdpLabBenefits = (planBenefitsResponse) => {
    const labHipaaCodes = ['05'];
    const serviceLevelBenefits = planBenefitsResponse?.data?.member?.serviceLevelBenefits || [];
    const response = serviceLevelBenefits.some((benefit) => {
        return labHipaaCodes.includes(benefit?.tieredHipaaService?.hipaaServiceTypeCode);
    });
    return response;
};

/**
 * Uses plan details response to determine whether a member has ddp Radiology/Imaging Benefits, relevant for rate/cost calculation
 * @param {Object} planBenefitsResponse response returned from our plan /benefits endpoint which holds the member's plan detail info
 * @returns {Boolean} true if member has a service level benefit for radiology/imaging services, else false
 */
export const determineDdpRadiologyBenefits = (response) => {
    const radiologyHipaaCodes = ['04', '06', '62'];
    const serviceLevelBenefits = response?.data?.member?.serviceLevelBenefits || [];
    return serviceLevelBenefits.some((benefit) => {
        return radiologyHipaaCodes.includes(benefit?.tieredHipaaService?.hipaaServiceTypeCode);
    });
};
